module.exports = __webpack_public_path__ + "static/media/project-7.c7ca8a0d.jpg";